import Vue from 'vue';

let filters = {
    dateFormat(value, fmt='yyyy-MM-dd hh:mm:ss') {
        if(!value) return '';
        value = value.replace(/-/g, '/');
        let getDate = new Date(value);
        let o = {
            'M+': getDate.getMonth() + 1,
            'd+': getDate.getDate(),
            'h+': getDate.getHours(),
            'm+': getDate.getMinutes(),
            's+': getDate.getSeconds(),
            'q+': Math.floor((getDate.getMonth() + 3) / 3),
            'S': getDate.getMilliseconds()
        };
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (let k in o) {
            if (new RegExp('(' + k + ')').test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
            }
        }
        return fmt;
    },
    computerDataFormat(bytes){
        if (bytes === 0) return '0 B';
        var k = 1024, // or 1024
            sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));
        return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
    },
    // 距离格式
    distanceDataFormat(distance){
		if (distance === undefined) return ''
        if (!distance) return '0m'
        if (distance > 1000) {
            return Math.floor(distance/100)/10 + 'km'
        } else {
            return Math.floor(distance) + 'm'
        }
    }
};


Object.keys(filters).forEach(key => Vue.filter(key, filters[key]));



// WEBPACK FOOTER //
// ./src/assets/js/filters.js